<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; padding: 0 24px; overflow: hidden;">
            <InfinityScroll ref="infinityScroll" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="() => {}" style="height: 100%;">
                <div style="font-size: 28px; font-weight: 700; line-height: 36px; margin-top: 41px;">어떤 입단 요청서를<br>보내시겠어요?</div>
                <div style="font-size: 14px; line-height: 24px; font-weight: 500; columns: #797979;">카드를 탭하여 전송할 요청서를 선택해 주세요.<br>내용 수정을 원하시면 상세보기를 눌러 수정할 수 있습니다.</div>
                <div style="border-radius: 12px; padding: 10px; background-color: #D9D9D9; display: flex; gap: 10px; align-items: center; margin-top: 5px; margin-bottom: 20px;">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <div style="width: 12px; height: 12px; background-color: #fff0e7; border-radius: 4px;"></div>
                        <div>:</div>
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">일반 입단 요청서</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <div style="width: 12px; height: 12px; background-color: #273344; border-radius: 4px;"></div>
                        <div>:</div>
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">시크릿 입단 요청서</div>
                    </div>
                </div>
                <div style="padding-bottom: 24px;">
                    <div
                        @click="selectSoccerhow(each)"
                        v-for="(each, i) in soccerHows"
                        :key="each.idx + '_' + i"
                        :class="['request_card', { dark: isSecretType(each.type), selected: selectedSoccerhows.idx === each.idx }]"
                    >
                        <div v-if="isSecretType(each.type)" class="secret_tag">시크릿 입단 요청서</div>
                        <div :class="['card_title', { dark: isSecretType(each.type) }]">{{ each.additional_info_introduce }}</div>
                        <div :class="['card_desc', { dark: isSecretType(each.type) }]">{{ each.contents }}</div>
                        <div :class="['card_date', { dark: isSecretType(each.type) }]">
                            {{ each.insert_date | dotDateStr }}{{ each.update_date && each.update_date !== each.insert_date ? '・수정됨' : '・작성' }}
                        </div>
                        <div v-if="selectedSoccerhows.idx === each.idx" class="selected_tag">
                            <img style="width: 12px;" :src="require('@/assets/img/white_check.png')" alt="">
                            <div>선택됨</div>
                        </div>
                        <div @click.stop="showDetail(each)" class="show_detail_tag">
                            <div>상세보기</div>
                            <img style="width: 7px;" :src="require('@/assets/img/black_arrow.png')" alt="">
                        </div>
                    </div>

                    <div @click="confirmSoccerhowDraft" class="new_request_btn">
                        <span class="plus_icon">+</span>
                        <span style="font-weight: 700; color: #797979;">새 입단 요청서 작성하기</span>
                    </div>
                </div>
            </InfinityScroll>
        </div>
        <div style="height: 90px; padding: 0 24px;">
            <div @click="confirmSendRequest" :class="Object.keys(selectedSoccerhows).length > 0 ? 'active' : 'un_active'" style="height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 12px; font-weight: 700; font-size: 14px;">입단 요청서 보내기</div>
        </div>
        <CommonConfirmFrame v-if="isShowConfirmPopup" :isShowConfirmPopup="isShowConfirmPopup" :closeConfirmPopup="closeConfirmPopup">
            <div class="confirm_draft_content">
                <div style="font-weight: 700; font-size: 20px; line-height: 24px;">이 입단 요청서를 보내시겠습니까?</div>
                <div style="margin-top: 5px; line-height: 24px; font-size: 14px; color: #808080;">
                    다른 요청서랑 헷갈리신 거 아니죠? 🧐<br>
                    선택하신 요청서가 맞는지 꼭 확인해 주세요!
                </div>
                <div class="confirm_btn_row">
                    <div @click="closeConfirmPopup" class="confirm_btn_new">나가기</div>
                    <div @click="sendRequest" class="confirm_btn_continue">입단 요청서 보내기</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <MakeRequestJoinForm 
            :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" 
            :isFromReportList="true" 
            :soccerhowIdx="selectedSoccerhows.idx"
            :closeRequestJoinForm="closeRequestJoinForm">
        </MakeRequestJoinForm>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { SOCCER_HOW_TYPE, FORM_MODE } from '@/Constants'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'

export default {
    name: 'SendRequestList',
    components: {
        MercenaryHeader,
        InfinityScroll,
        CommonConfirmFrame,
        MakeRequestJoinForm
    },
    data() {
        return {
            soccerHows: [],
            FORM_MODE: FORM_MODE,
            page: 1,
            isEnableNextPageHandle: true,
            isShowConfirmPopup: false,
            soccerhow_draft: {},
            selectedSoccerhows: {},
            isShowMakeRequestJoinForm: false
        }
    },
    created() {
        this.getMySoccerHow()
    },
    methods: {
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false
        },
        confirmSendRequest() {
            if (Object.keys(this.selectedSoccerhows).length === 0) {
                this.$GlobalStore.showAlert('입단 요청서를 선택해주세요.')
                return
            }
            this.isShowConfirmPopup = true
        },
        sendRequest() {
            this.isShowConfirmPopup = false
            this.isShowMakeRequestJoinForm = true
        },
        showDetail(each) {
            this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: each.idx, is_parent_verified: each.is_parent_verified })
        },
        handleNextPage() {
            this.page++
            this.getMySoccerHow()
        },
        isSecretType() {
            return false
        },
        closeConfirmPopup() {
            this.isShowConfirmPopup = false
        },
        async getMySoccerHow() {
            this.isEnableNextPageHandle = false
            // 타입 바꿔서
            const types = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            const parameters = {}
            parameters.page = this.page
            parameters.type = types
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;
            parameters.writer_idx = this.$GlobalStore.loginInfo().idx
            parameters.writer_type = this.$GlobalStore.loginInfo().member_type

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const soccerHows = res.data.soccerHows
            
            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                this.soccerHows = [...this.soccerHows, ...soccerHows]
            }
        },
        async confirmSoccerhowDraft() {
            const res = await this.$Axios.get('/api/soccerhow/get/draft')
            if (res.data.soccerhow_draft) {
                this.isShowConfirmPopup = true
                this.soccerhow_draft = res.data.soccerhow_draft
            } else {
                this.selectPlayerType()
            }
        },
        selectPlayerType() {
            this.$GlobalStore.addModal('SelectPlayerType')
        },
        goToModifyRequest(each) {
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowIdx: each.idx, mode: FORM_MODE.UPDATE });
        },
        selectSoccerhow(each) {
            if (this.selectedSoccerhows.idx === each.idx) {
                this.selectedSoccerhows = {}
            } else {
                this.selectedSoccerhows = each
            }
        },
        async deleteDraft() {
            const res = await this.$Axios.post('/api/soccerhow/delete/draft')
            if (res.data.code === 0) {
                this.isShowConfirmPopup = false
                this.selectPlayerType()
            }
        },
        writeDefaultInfoForm() {
            this.isShowConfirmPopup = false
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowDraft: this.soccerhow_draft, isDraft: true, playerType: this.soccerhow_draft.player_type })
        },
    }
}   
</script>

<style scoped>
.request_card {
    padding: 24px 12px;
    border-radius: 24px;
    margin-bottom: 20px;
    background: #FF71111A;
    position: relative;
    border: 2px solid transparent;
}
.request_card.dark {
    background: linear-gradient(180deg, rgba(33, 15, 3, 0.6) 0%, rgba(80, 80, 90, 0.8) 100%);
}
.request_card.selected {
    border: 2px solid var(--color-main);
}
.secret_tag {
    position: absolute;
    top: 12px;
    left: 12px;
    background: #FF7111;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 4px;
}
.card_title {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
}
.card_title.dark {
    color: #fff;
}
.card_desc {
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.card_desc.dark {
    color: rgba(255, 255, 255, 0.9);
}
.card_date {
    font-weight: 700;
    font-size: 12px;
    color: #797979;
    line-height: 24px;
}
.card_date.dark {
    color: rgba(255, 255, 255, 0.7);
}
.new_request_btn {
    margin-top: 16px;
    padding: 24px;
    border: 2px dashed #D9D9D9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    background: #fff;
}
.new_request_btn .plus_icon {
    font-size: 24px;
    font-weight: 300;
    color: #808080;
}
.new_request_btn span:last-child {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.confirm_draft_content {
    position: relative;
    text-align: center;
    padding: 8px;
    /* min-width: 280px; */
}

.confirm_close_btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 1px 9.1px 0px #00000014;
    cursor: pointer;
}

.confirm_icon_wrapper {
    width: 40px;
    height: 40px;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #FF71111A;
}

.confirm_title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 5px;
}

.confirm_desc {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #808080;
    margin-bottom: 30px;
}

.confirm_btn_row {
    display: flex;
    gap: 12px;
    margin-top: 20px;
}

.confirm_btn_new {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid #d9d9d9;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 35%;
}

.confirm_btn_continue {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: var(--color-main);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 65%;
}

.active {
    background-color: var(--color-main);
    color: #fff
}

.un_active {
    background-color: #d9d9d9;
    color: #797979;
}

.selected_tag {
    border-radius: 34px; 
    font-size: 12px; 
    justify-content: center; 
    color: #fff; 
    background-color: var(--color-main); 
    display: flex; 
    align-items: center; 
    gap: 4px; 
    width: 64px; 
    height: 32px;
    position: absolute;
    top: -14px;
    right: 3px;
}

.show_detail_tag {
    width: 86px;
    height: 28px;
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    color: #210F03;
    font-size: 12px;
    font-weight: 700;
    padding: 0 8px;
    position: absolute;
    right: 16px;
    bottom: 24px;

}
</style>